import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=b410c08a&scoped=true&"
import script from "./Bill.vue?vue&type=script&lang=ts&"
export * from "./Bill.vue?vue&type=script&lang=ts&"
import style0 from "./Bill.vue?vue&type=style&index=0&id=b410c08a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410c08a",
  null
  
)

export default component.exports